import { Route } from '@/app/router'

const Stack = () => import('./index.vue')

export default new Route('/stack', Stack)
	.as('Dashboard:Stack')
